<template>
  <product-about-card v-if="branch?.facilities?.length" class="product-facilities" :title="$t('branch_detail.about.facilities')">
    <product-facilities-list class="gap-2" :facilities="branch.facilities.slice(0, DISPLAY_VIEW_ALL_BTN_COUNT)" />

    <content-viewer
      v-if="isViewAllBtnShown"
      :title="$t('branch_detail.about.facilities')"
      :is-full-height="true"
      :is-footer-shown="false"
      :is-fallback-shown="true"
      main-content-class="pt-0 pb-4"
    >
      <template #trigger="{ open }">
        <product-view-all-button @view-all-click="open" />
      </template>
      <product-facilities-list item-class="py-4" :facilities="branch.facilities" />
    </content-viewer>
  </product-about-card>
</template>

<script lang="ts" setup>
import ContentViewer from '@/components/common/content-viewer.vue'
import ProductFacilitiesList from '@/components/product/product-detail/product-facilities-list.vue'
import ProductViewAllButton from '@/components/product/product-detail/product-view-all-button.vue'
import ProductAboutCard from '@/components/product/product-detail/product-about-card.vue'

const { branch } = useBranchDetailContext()

const DISPLAY_VIEW_ALL_BTN_COUNT = 4

const isViewAllBtnShown = computed(() => (branch.value?.facilities?.length || 0) > DISPLAY_VIEW_ALL_BTN_COUNT)
</script>
